import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Dservice from "../../components/UserComponents/service/Dservice";

const Service = () => {
  const { id } = useParams();
  const [serviceData, setServiceData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0)
    const fetchService = async () => {
      // console.log("Fetching service with id:", id);
      try {
        setLoading(true);
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/service/get-service/${id}`, {
          // withCredentials: true,
        });

        if (res.data.success) {
          setServiceData(res.data.services[0]);
          // console.log("Fetched service data:", res.data.services[0]);
        } else {
          setError(res.data.message || "Failed to fetch service");
        }
      } catch (err) {
        console.error("Error fetching service:", err);
        setError("Error fetching service. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchService();
  }, [id]);

  return (
    <div>
      <Dservice service={serviceData} loading={loading} error={error} serviceData={serviceData} />
    </div>
  );
};

export default Service;